import { writable } from 'svelte/store';
import { z } from 'zod';
import { ColumnSettingsSchema } from './types';

/*
{
  "created": "2023-11-22 21:42:09",
  "filename": null,
  "webuser_id": -1,
  "uploaded": null,
  "columns_assigment": null,
  "id": 10
}
 */

export const ImportFileTypeSchema = z
    .enum(['connections', 'locations'])
    .describe('connections | locations');
export type ImportFileTypeType = z.infer<typeof ImportFileTypeSchema>;

export const ImportCreateRequestSchema = z.object({
    name: z.string(),
    file_type: ImportFileTypeSchema,
    import_type: z.string().catch('upsert').describe('upsert | overwrite'),
    columns_assignment: ColumnSettingsSchema.optional(),
});
export type ImportCreateRequestType = z.infer<typeof ImportCreateRequestSchema>;

export const ImportRequestSchema = z.object({
    target_date: z.string().nullable(),
    history_import: z
        .boolean()
        .catch(false)
        .describe('import history https://er.automapa.pl/issues/45796'),
    columns_assignment: ColumnSettingsSchema.nullable(),
});
export type ImportRequestType = z.infer<typeof ImportRequestSchema>;

export const ImportResponseSchema = ImportRequestSchema.merge(
    z.object({
        created: z.string(),
        file_type: ImportFileTypeSchema,
        import_type: z.string().describe('upsert | overwrite'),
        filename: z.string().nullable(),
        id: z.coerce.number(),
        webuser_id: z.coerce.number(),
        uploaded: z.string().nullable(),
        geocode_completed: z.boolean(),
        jobs_created: z.boolean(),
        temporary_file_extension: z.string().catch('').describe('ods|csv|xlsx|xls'),
        error: z.string().nullable().catch(null).describe('timestamp of error'),
        geocoding_started: z
            .string()
            .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)
            .nullable(),
    })
).nullable();
export type ImportResponseType = z.infer<typeof ImportResponseSchema>;

export let currentImport = writable<ImportResponseType>(null);

// {"tasks_total":6,"tasks_done":6,"percent":100}

export const TasksStatusResponseSchema = z.object({
    tasks_total: z.number(),
    tasks_done: z.number(),
    percent: z.number(),
});
export type TasksStatusResponseType = z.infer<typeof TasksStatusResponseSchema>;
